import css from 'styled-jsx/css';
import { display } from 'styles/css-constants';

export default css`
  .AmpFaq {
    margin-bottom: 1rem;
  }
  .AmpFaq header {
    padding: 0;
    background-color: transparent;
    border: none;
  }
  .AmpFaq header h3 {
    margin: 0;
    padding: 0 0.25rem;
    display: flex;
    align-items: flex-start;
    font-size: var(--fontScale2);
    font-weight: bold;
    font-family: ${display};
    line-height: 1.4;
  }
  .AmpFaq header h3 span {
    margin-right: 0.5rem;
    color: #999;
    flex: 0 0 1.75rem;
  }
  .AmpFaq__body {
    margin: 0.75rem 0;
  }
  .AmpFaq__item {
    margin: 1rem 0;
  }
`;
